<template>
  <div id="app">
    <b-navbar
      v-if="$store.getters.user"
      sticky
      style="overflow: visible; min-height:74px"
      type="dark"
      variant="dark"
    >
      <b-navbar-brand href="#">
        <b-img :src="logo"/>
      </b-navbar-brand>
      <b-navbar-nav>
        <b-nav-item to="/people">&#128270; Vyhledávání osob</b-nav-item>
        <b-nav-item to="/people-new">&#128378; Nová osoba</b-nav-item>
        <b-nav-item to="/selections">&#9733; Výběry</b-nav-item>
        <b-nav-item to="/people-outdated">&#128248; Osoby k aktualizaci</b-nav-item>
        <b-nav-item to="/smssent">&#9993; SMS</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!--b-nav-item to="/help">Nápověda</b-nav-item-->
        <b-nav-item-dropdown text="Nastavení" right>
          <b-dropdown-item v-b-modal.changePassword>Změna hesla</b-dropdown-item>
          <b-dropdown-item v-if="$store.getters.isAdmin" to="/users">Uživatelé</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item right to="/">Odhlásit</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <router-view style="flex: auto;"/>

    <b-modal id="changePassword" title="Změna Hesla">
      <b-row>
        <b-col md="12">
          <b-form-group label="Staré heslo:" label-for="inputOldPassword">
            <b-form-input
              v-model="password.oldPassword"
              id="inputOldPassword"
              type="password"
              size="sm"
              required
            />
          </b-form-group>

          <b-form-group label="Nové heslo: (min 6 znaků)" label-for="inputNewPassword">
            <b-form-input
              v-model="password.newPassword"
              id="inputNewPassword"
              :state="newPasswordLength"
              type="password"
              size="sm"
              required
            />
          </b-form-group>

          <b-form-group label="Potvrzení hesla:" label-for="inputConfirmNewPassword">
            <b-form-input
              v-model="password.confirmNewPassword"
              id="ConfirmNewPassword"
              :state="confirmNewPasswordLength"
              type="password"
              size="sm"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button size="sm" variant="success" @click="changePassword()">Uložit</b-button>
        <b-button size="sm" variant="danger" @click="$bvModal.hide('changePassword')">Zrušit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'App',
  data () {
    return {
      logo: require('./assets/logo.png'),
      password: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      }
    }
  },
  mounted () {
    this.$store
      .dispatch('checkLogin')
      .catch(() => this.$router.push('/'))
  },
  computed: {
    newPasswordLength () {
      return this.password.newPassword.length > 5
    },
    confirmNewPasswordLength () {
      return this.password.confirmNewPassword.length > 5
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    changePassword () {
      if (this.password.new === this.password.confirmNew) {
        console.log(this.password)
        axios
          .post('/api/v1/user', this.password)
          .then(response => {
            console.log('pChange: ', response.data)
            this.password.oldPassword = ''
            this.password.newPassword = ''
            this.password.confirmNewPassword = ''
            this.$bvModal.hide('changePassword')
            this.$bvToast.toast(`Heslo bylo změněno`, {
              title: 'Hotovo',
              variant: 'success',
              autoHideDelay: 1500
            })
          })
          .catch(error => {
            console.log('err')
            console.log(error.response.data)
            this.$bvToast.toast(`Je púvdné heslo správně?`, {
              title: 'Chyba změny hesla',
              variant: 'danger',
              autoHideDelay: 2000
            })
          })
      } else {
        this.$bvToast.toast(`Heslo a Potvrzovací heslo se neshodují!!!`, {
          title: 'Chyba!!!',
          variant: 'danger',
          autoHideDelay: 2000
        })
      }
    }
  }
})
</script>

<style>
body {
  background-color: #f0f0f0;
}

h1 {
  padding: 0;
  margin-top: 0;
}

#app {
  margin: auto;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #121812;
}

#nav a {
  font-weight: bold;
  color: #d9e1e9;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
